import React from 'react';
import { Box, Switch, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useUserAppSetting, useUpdateUserAppSettingsMutation } from '@/modules';

const HieNetworkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width="20px"
    height="20px"
  >
    <path
      fill="#4caf50"
      d="M6,10c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4v28c0,2.2-1.8,4-4,4H10c-2.2,0-4-1.8-4-4V10z"
    />
    <path
      fill="#c8e6c9"
      d="M23 26.5L23 13 25 13 25 23.5 35.6 19.1 36.4 20.9z"
    />
    <path
      fill="#c8e6c9"
      d="M16.8 35.6L15.2 34.4 22.3 25.5 11.7 21.9 12.3 20.1 25.7 24.5z"
    />
    <path
      fill="#c8e6c9"
      d="M27 23.6H29V36.400000000000006H27z"
      transform="rotate(-38.659 27.998 29.999)"
    />
    <path
      fill="#e8f5e9"
      d="M27 13c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3S27 11.3 27 13zM39 20c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3S39 18.3 39 20zM29 25c0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5S29 22.2 29 25zM15 21c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3S15 19.3 15 21zM19 35c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3S19 33.3 19 35zM35 35c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3S35 33.3 35 35z"
    />
  </svg>
);

const ToggleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(0.5, 1),
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.primary.main
  }
}));

const IconWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active'
})<{ active: boolean }>(({ active }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  opacity: active ? 1 : 0.5,
  transition: 'opacity 0.2s ease-in-out',
  '& svg': {
    filter: active ? 'none' : 'grayscale(100%)'
  }
}));

export const PatientsAppToggle = () => {
  const currentValue = useUserAppSetting('patientsAppIntegrationEnabled', true);
  const [updateSettings] = useUpdateUserAppSettingsMutation();

  const handleToggle = () => {
    updateSettings({ patientsAppIntegrationEnabled: !currentValue });
  };

  return (
    <Tooltip
      title={
        currentValue ? 'HIE integration enabled' : 'HIE integration disabled'
      }
      placement="bottom"
    >
      <ToggleContainer>
        <IconWrapper active={currentValue}>
          <HieNetworkIcon />
        </IconWrapper>
        <Switch
          checked={currentValue}
          onChange={handleToggle}
          size="small"
          color="primary"
        />
      </ToggleContainer>
    </Tooltip>
  );
};
